import { createContainer } from 'react-sweet-state';

import { type CommonContainerProps } from 'src/lib/sweetState';

import { type Actions, MainStore, PRIVATE_ACTIONS, type State } from './MainStore';

export interface ContainerProps extends CommonContainerProps<State> {
  currentCustomerId?: string;
}

export const MainStoreContainer = createContainer<State, Actions, ContainerProps>(MainStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(PRIVATE_ACTIONS.initStore());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
